<template>
    <information-popup modal-id="inscriptionGuidelinesPopup">
        <template slot="header">Inscription Guidelines</template>
        <slot>
            <div class="modal-body">
                16 characters allowed per line. Characters include all letters, numbers, punctuation marks,
                and blank spaces found on a standard English keyboard.
                Inscriptions will be automatically centered and engraved in uppercase letters.
                Inscriptions that contain websites, phone numbers, twitter handles, and/or manifestos are not permitted.
                Discriminatory, political, offensive or inappropriate messages as determined by D.C. United will be declined.
            </div>
        </slot>
    </information-popup>
</template>

<script type="text/jsx">
    import InformationPopup from '@/components/popup/information-popup.vue';
    export default {
        name: 'inscription-guidelines',
        components: {
            'information-popup': InformationPopup
        }
    }
</script>



// WEBPACK FOOTER //
// InscriptionGuidelines.vue?57566931